/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerConfigResponse
 */
export interface CustomerConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof CustomerConfigResponse
     */
    claimFormInactivityTimeoutMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigResponse
     */
    freshdeskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigResponse
     */
    timezone: string;
}

/**
 * Check if a given object implements the CustomerConfigResponse interface.
 */
export function instanceOfCustomerConfigResponse(value: object): value is CustomerConfigResponse {
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    return true;
}

export function CustomerConfigResponseFromJSON(json: any): CustomerConfigResponse {
    return CustomerConfigResponseFromJSONTyped(json, false);
}

export function CustomerConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimFormInactivityTimeoutMs': json['claimFormInactivityTimeoutMs'] == null ? undefined : json['claimFormInactivityTimeoutMs'],
        'freshdeskId': json['freshdeskId'] == null ? undefined : json['freshdeskId'],
        'timezone': json['timezone'],
    };
}

export function CustomerConfigResponseToJSON(value?: CustomerConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimFormInactivityTimeoutMs': value['claimFormInactivityTimeoutMs'],
        'freshdeskId': value['freshdeskId'],
        'timezone': value['timezone'],
    };
}

